import React from 'react';
import { getArray } from '../../../utils/helpers';

import teamMember1 from "../../../assets/gallary_1.jpg";
import teamMember2 from "../../../assets/gallary_2.jpg";
import teamMember3 from "../../../assets/gallary_3.png";
import teamMember4 from "../../../assets/gallary_4.jpg";
import teamMember5 from "../../../assets/gallary_5.jpg";
import teamMember6 from "../../../assets/gallary_6.jpg"

const OurTeam = ({ t }) => {

    const teamImages = {
        "happy-chef-e1686242017828": teamMember1,
        "chef-posing-e1686586881786": teamMember2,
        "handsome-young-man-with-knife-posing-in-kitchen": teamMember3,
        "young-female-chef-in-uniform-carrying-a-cake-tray-giving-a-thumbs-up": teamMember4,
        "chef-in-love-with-his-job": teamMember5,
        "apprentice-chef-e1686588927740": teamMember6,
    };

    return (
        <section className="py-24 bg-[#FFEDE1]">
            <div className="container mx-auto px-4 max-w-[75rem]">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Title and Subtitle */}
                    <div className="lg:col-span-2">
                        <h5 className="text-[#C7702A] uppercase mb-2 font-['Jost',sans-serif] text-[0.9375rem] font-normal">{t?.teamTitle}</h5>
                        <h2 className="text-[#1F0707] font-['__Libre_Caslon_Display_20614e'] text-[2.5rem] font-medium tracking-[-0.0375rem] leading-[3rem] mb-6">{t?.teamSubTitle}</h2>
                    </div>

                    {/* Team member cards */}
                    {getArray(Object.keys(teamImages)).map((key, index) => (
                        <div key={index} className="bg-white shadow-lg overflow-hidden relative group">
                            <img 
                                src={teamImages[key]}
                                alt={index}
                                width={300}
                                height={400}
                                className="w-full h-64 object-cover transition-opacity duration-300 group-hover:opacity-80"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default OurTeam;
